import type { SVGProps } from "react";
export interface BinaryIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BinaryIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BinaryIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.375 20v-3.444a1.12 1.12 0 0 1-1.17-1.851l1.5-1.5a1.126 1.126 0 0 1 1.92.795v6a1.125 1.125 0 0 1-2.25 0m18.5 0v-3.444a1.121 1.121 0 0 1-1.17-1.851l1.5-1.5a1.126 1.126 0 0 1 1.92.795v6a1.125 1.125 0 0 1-2.25 0m-6-1.125h1v-3.75h-1zm-6.75 0h1v-3.75h-1zm3.25.125a2.126 2.126 0 0 1-2.125 2.125H8A2.126 2.126 0 0 1 5.875 19v-4c0-1.173.951-2.125 2.125-2.125h1.25c1.173 0 2.125.952 2.125 2.126zm6.75 0a2.126 2.126 0 0 1-2.126 2.125H14.75A2.126 2.126 0 0 1 12.624 19v-4c0-1.173.952-2.125 2.126-2.125H16c1.173 0 2.125.952 2.125 2.126zm-9-9V6.556a1.12 1.12 0 0 1-1.17-1.851l1.5-1.5a1.126 1.126 0 0 1 1.92.795v6a1.125 1.125 0 0 1-2.25 0m11.75 0V6.556a1.121 1.121 0 0 1-1.17-1.851l1.5-1.5a1.126 1.126 0 0 1 1.92.795v6a1.125 1.125 0 0 1-2.25 0m-6-1.125h1v-3.75h-1zm-11.75 0h1v-3.75h-1zm3.25.124a2.126 2.126 0 0 1-2.125 2.126H3A2.126 2.126 0 0 1 .875 8.999V5c0-1.173.952-2.125 2.125-2.125h1.25c1.174 0 2.125.952 2.125 2.125zm11.75 0a2.126 2.126 0 0 1-2.126 2.126H14.75a2.126 2.126 0 0 1-2.126-2.126V5c0-1.173.952-2.125 2.126-2.125H16c1.173 0 2.125.952 2.125 2.125z"
      />
    </svg>
  );
}
